import React from 'react';
import { ImHtmlFive } from 'react-icons/im';
import { DiCss3 } from 'react-icons/di';
import { DiSass } from 'react-icons/di';
import { BsFillBootstrapFill } from 'react-icons/bs';
import { SiTailwindcss } from 'react-icons/si';
import { IoLogoJavascript } from 'react-icons/io';
import { SiTypescript } from 'react-icons/si';
import { GrReactjs } from 'react-icons/gr';
import { SiFigma } from 'react-icons/si';

import { FaNodeJs } from 'react-icons/fa';
import { SiMongodb } from 'react-icons/si';
import { SiFirebase } from 'react-icons/si';
import { SiJest } from 'react-icons/si';
import { TbBrandNextjs } from 'react-icons/tb';
import { SiJsonwebtokens } from 'react-icons/si';
import { TbBrandReactNative } from 'react-icons/tb';


const Skills = () => {

    return (
        <div name="skill" className='bg-[#EAEAEA] h-screen w-full flex flex-col justify-center items-center '>

            {/* Proficient */}
            <div className='flex flex-col justify-center items-center px-4'>
            <h2 className='text-2xl pb-6 pt-12'>I'm Proficient in</h2>
            <div className='grid grid-cols-3 gap-6'>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <ImHtmlFive/> <span>HTML</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <DiCss3/> <span>CSS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <DiSass/> <span>SASS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <BsFillBootstrapFill/> <span>Bootstrap</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiTailwindcss/> <span>TailwindCSS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <IoLogoJavascript/> <span>JavaScript</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiTypescript/> <span>TypeScript</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <GrReactjs/> <span>ReactJS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiFigma/> <span>Figma</span>
                </div>
            </div>
            </div>

            {/* Comfortable */}

            <div className='flex flex-col justify-center items-center pt-4'>
            <h2 className='text-2xl py-6'>Comfortable With</h2>
            <div className='grid grid-cols-3 gap-6'>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <FaNodeJs/> <span>NodeJS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiMongodb/> <span>MongoDB</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiFirebase/> <span>Firebase</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiJsonwebtokens/> <span>JWT</span>
                </div>
            </div>
            </div>

            {/* Exploring */}
            <div className='flex flex-col justify-center items-center px-4'>
            <h2 className='text-2xl py-6'>Exploring</h2>
            <div className='grid grid-cols-3 gap-6'>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <TbBrandNextjs/> <span>NextJS</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <SiJest/> <span>JEST</span>
                </div>
                <div className='flex items-center gap-2 p-1 shadow-lg shadow-teal-500/50 rounded'>
                <TbBrandReactNative/> <span>React Native</span>
                </div>
            </div>
            </div>

        </div>
    );
};

export default Skills;